export const types = {
    TYRE_CAR: 'tyre',
    TYRE_MOTO: 'tyre_moto',
    ACCESSORY: 'accessory',
    WHEEL: 'wheel',
    TOOL: 'tool',
    ALL: 'all',
};
